<template>
    <el-dialog custom-class="new-guideline-dialog"
               :close-on-click-modal="false"
               title="新手操作指引"
               @open="openConfig" @close="closeDialog" width="1200px" @before-close="closeDia"
               :visible.sync="dialogVisible">

        <el-tabs tab-position="left" v-model="currentTabs" class="common-left-tabs">
            <el-tab-pane name="0">
                <div class="tab-item">
                    <tabzero @step="step"></tabzero>
                    <p class="step" @click="step('1')">下一点</p>
                </div>
            </el-tab-pane>
            <el-tab-pane name="1" >
                <span slot="label">
                    <i class="iconfont icon-shipin1 tab-icon"></i>
                    新手视频
                </span>
                    <tabOne @step="step" v-if="currentTabs=='1'"></tabOne>
            </el-tab-pane>
            <el-tab-pane name="2">
                <span slot="label">
                   <i class="iconfont icon-gerenzhongxin tab-icon"></i>
                    快速登录
                </span>
                <tabTwo v-if="currentTabs === '2'" @step="step"></tabTwo>
            </el-tab-pane>

            <el-tab-pane name="3">
                <span slot="label">
                     <i class="iconfont icon-xiangyingshi tab-icon"></i>
                    创建网站
                </span>
                <tabThree v-if="currentTabs === '3'" @step="step"></tabThree>
            </el-tab-pane>
            <el-tab-pane name="4">
                <span slot="label">
                   <i class="iconfont icon-yemian tab-icon"></i>
                    添加页面
                </span>
                <tabFour v-if="currentTabs === '4'" @step="step"></tabFour>
            </el-tab-pane>
            <el-tab-pane name="5">
                <span slot="label">
                     <i class="iconfont icon-wenzi tab-icon"></i>
                    改文字
                </span>
                <tabFive v-if="currentTabs === '5'" @step="step"></tabFive>
            </el-tab-pane>
            <el-tab-pane name="6">
                <span slot="label">
                    <i class="iconfont icon-picture tab-icon"></i>
                    换图片
                </span>
                <tabSix v-if="currentTabs === '6'" @step="step"></tabSix>
            </el-tab-pane>
            <el-tab-pane name="7">
                <span slot="label">
                    <i class="icon3 i-tpl-dialog-w" v-if="currentTabs === '7'">
                    </i><i class="icon3 i-tpl-dialog-w2" v-else></i>
                    更换域名
                </span>
                <tabSeven v-if="currentTabs === '7'" @step="step"></tabSeven>
            </el-tab-pane>
            <el-tab-pane name="8">
                <span slot="label">
                    <i class="icon3 i-tpl-site2" v-if="currentTabs === '8'"></i>
                    <i class="icon3 i-tpl-site1" v-else></i>
                    网站发布
                </span>
                <tabEight v-if="currentTabs === '8'"></tabEight>
            </el-tab-pane>
        </el-tabs>

    </el-dialog>
</template>

<script>
import tabzero from './TabComponent/TabZero'
import tabOne from './TabComponent/TabOne'
import tabTwo from './TabComponent/TabTwo'
import tabThree from './TabComponent/TabThree'
import tabFour from './TabComponent/TabFour'
import tabFive from './TabComponent/TabFive'
import tabSix from './TabComponent/TabSix'
import tabSeven from './TabComponent/TabSeven'
import tabEight from './TabComponent/TabEight'

export default {
	name: 'NewGuideline',
	components: {
		tabzero,
		tabOne,
		tabTwo,
		tabThree,
		tabFour,
		tabFive,
		tabSix,
		tabSeven,
		tabEight
	},
	props:['flag'],
	data () {
		return {
			currentTabs: '0',
			dialogVisible: false
		}
	},
	created () {
		this.dialogVisible = this.flag
	},
	computed: {

	},
	methods: {
		openConfig () {

		},
		closeDia () {
			console.log(2)
			this.$emit('close')
			this.dialogVisible = false
		},
		closeDialog() {
			this.$emit('close')
			this.dialogVisible = false
		},
		step(val) {
			this.currentTabs = val
		}
	}
}
</script>

<style scoped lang="scss">
    .guide-img{
        width: 25px;
        height: 25px;vertical-align: middle;margin-right:15px;
    }
    .tab-icon{
        font-size:28px;margin-right:12px;
    }
    .tab-item{

        .step{
            position:absolute;right:20px;bottom:0px;cursor:pointer;
            line-height: 40px;
        }
    }
    span{
        color:#515567;
    }
</style>
